import { render, staticRenderFns } from "./Rankings.vue?vue&type=template&id=42fba9aa&scoped=true"
import script from "./Rankings.vue?vue&type=script&lang=ts&setup=true"
export * from "./Rankings.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Rankings.vue?vue&type=style&index=0&id=42fba9aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fba9aa",
  null
  
)

export default component.exports